// Updated Profile.js — with switch case logic preserved for testing

import React, { useState, useEffect } from "react";
import { Jumbotron, Row, Col, OverlayTrigger, Tooltip } from "react-bootstrap";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import { Line } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Tooltip as ChartTooltip, Legend } from 'chart.js';
import { useAuth0 } from "@auth0/auth0-react";
import { config } from '../../Config/Constants';
import styled from 'styled-components';

ChartJS.register(LineElement, PointElement, CategoryScale, LinearScale, ChartTooltip, Legend);

const API_URL = config.url.API_URL;

const Div = styled.div`
  .profilepics {
    border-radius: 50%;
    width: 25%;
    height: auto;
  }
`;

const getWorkdays = (start, end) => {
  let count = 0;
  const current = new Date(start);
  while (current <= end) {
    const day = current.getDay();
    if (day !== 0 && day !== 6) count++;
    current.setDate(current.getDate() + 1);
  }
  return count;
};

const Profile = () => {
  const { user } = useAuth0();

  const email = user.name; // Replace with user.name in production
  // const [weeklyData, setWeeklyData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [monthlyRollup, setMonthlyRollup] = useState(
    Array.from({ length: 12 }, () => ({
      billable_hours: 0,
      total_hours: 0,
      goal: 0,
      weeks: []
    }))
  );
  const [renderBillableHours, setRenderBillableHours] = useState(0);
  const [renderTotalHours, setRenderTotalHours] = useState(0);

  const currentKey = `${new Date().getFullYear()}-${String(new Date().getMonth() + 1).padStart(2, '0')}`;
  const currentMonthData = monthlyRollup.find(m => m.key === currentKey) || { billable_hours: 0, total_hours: 0, goal: 0 };

  let teamMemberName = "";
  let goal = 0;
  let hiredate = "";
  let birthday = "";
  let photo = "";

  switch (email) {
    case "anorton@pprhr.com":
      teamMemberName = "Adam Norton";
      goal = 0;
      hiredate = "11/14/2014";
      birthday = "10/12";
      photo = 'https://www.pprhr.com/assets/images/team/adam.jpg';
      break;
    case "canderson@pprhr.com":
      teamMemberName = "Candace Anderson";
      goal = 18000;
      hiredate = "03/29/2021";
      birthday = "02/11";
      photo = 'https://www.pprhr.com/assets/images/team/candace.jpg';
      break;
    case "gnorton@pprhr.com":
      teamMemberName = "Gabriela Norton";
      goal = 18000;
      hiredate = "02/01/2010";
      birthday = "07/16";
      photo = 'https://www.pprhr.com/assets/images/team/gabriela.jpg';
      break;
    case "hmccartney@pprhr.com":
      teamMemberName = "Haley McCartney";
      goal = 18000;
      hiredate = "08/12/2024";
      birthday = "12/02";
      photo = '';
      break;
    case "htibbetts@pprhr.com":
      teamMemberName = "Hayley Tibbetts";
      goal = 17000;
      hiredate = "03/10/2021";
      birthday = "12/29";
      photo = 'https://www.pprhr.com/assets/images/team/hayley.jpg';
      break;
    case "jkelly@pprhr.com":
      teamMemberName = "Jazmin Kelly";
      goal = 15000;
      hiredate = "08/01/2014";
      birthday = "09/15";
      photo = 'https://www.pprhr.com/assets/images/team/jazmin.jpg';
      break;
    case "khester@pprhr.com":
      teamMemberName = "Karen Hester";
      goal = 18000;
      hiredate = "01/01/2025";
      birthday = "04/13";
      photo = 'https://www.pprhr.com/assets/images/team/placeholder-female.jpg';
      break;
    case "kbenson@pprhr.com":
      teamMemberName = "Kacye Benson";
      goal = 15000;
      hiredate = "10/09/2017";
      birthday = "05/12";
      photo = 'https://www.pprhr.com/assets/images/team/kacye.jpg';
      break;
    case "llloyd@pprhr.com":
    case "lloyd@pprhr.com":
      teamMemberName = "Lauren Lloyd";
      goal = 0;
      hiredate = "02/21/2022";
      birthday = "05/05";
      photo = 'https://www.pprhr.com/assets/images/team/lauren.jpg';
      break;
    case "lbenson@pprhr.com":
      teamMemberName = "Luke Benson";
      goal = 20000;
      hiredate = "01/01/2022";
      birthday = "12/06";
      photo = 'https://www.pprhr.com/assets/images/team/luke.jpg';
      break;
    case "mcontreras@pprhr.com":
      teamMemberName = "Mercedes Contreras";
      goal = 20000;
      hiredate = "02/06/2023";
      birthday = "04/13";
      photo = 'https://www.pprhr.com/assets/images/team/placeholder-female.jpg';
      break;
    case "tmiller@pprhr.com":
      teamMemberName = "Tracy Miller";
      goal = 20000;
      hiredate = "04/18/2022";
      birthday = "05/21";
      photo = 'https://www.pprhr.com/assets/images/team/tracy.jpg';
      break;
    default:
      teamMemberName = "No Name Found";
      goal = 0;
      break;
  }

  useEffect(() => {
    setIsLoading(true);
    fetch(`${API_URL}/harvest/user-weekly/${teamMemberName}`)
      .then(res => res.json())
      .then(weeks => {
        const monthMap = {};

        weeks.forEach(week => {
          const start = new Date(week.start);
          const end = new Date(week.end);
          const workdays = getWorkdays(start, end);
          const monthKey = week.start.slice(0, 7);

          if (!monthMap[monthKey]) {
            monthMap[monthKey] = {
              billable_hours: 0,
              total_hours: 0,
              goal: 0,
              weeks: []
            };
          }

          monthMap[monthKey].billable_hours += week.billable_hours;
          monthMap[monthKey].total_hours += week.total_hours;
          monthMap[monthKey].goal += workdays * 7.2;
          monthMap[monthKey].weeks.push({ ...week, workdays, goal: workdays * 7.2 });
        });

        const sortedKeys = Object.keys(monthMap).sort();
        const rollup = sortedKeys.map(key => ({ ...monthMap[key], key }));

        setMonthlyRollup(rollup);

        // const currentMonth = new Date().getMonth();
        const currentKey = `${new Date().getFullYear()}-${String(new Date().getMonth() + 1).padStart(2, '0')}`;
        const currentMonthData = monthMap[currentKey] || { billable_hours: 0, total_hours: 0, goal: 0 };

        setRenderBillableHours(currentMonthData.billable_hours);
        setRenderTotalHours(currentMonthData.total_hours);
        setIsLoading(false);
      })
      .catch(err => {
        console.error("Error loading weekly metrics:", err);
        setIsLoading(false);
      });
  }, [teamMemberName]);

  const chartData = {
    labels: monthlyRollup.map((_, i) => new Date(0, i).toLocaleString('en', { month: 'short' })),
    datasets: [
      {
        label: 'Billable Hours',
        data: monthlyRollup.map(m => m.billable_hours),
        fill: false,
        borderColor: 'rgba(75,192,192,1)',
        borderWidth: 3,
        tension: 0.3
      },
      {
        label: 'Monthly Goal',
        data: monthlyRollup.map(m => m.goal),
        fill: false,
        borderColor: '#ccc',
        borderWidth: 3,
        borderDash: [5, 5],
        tension: 0.3
      }
    ]
  };

  const chartOptions = {
    responsive: true,
    plugins: {
      legend: { position: 'top', labels: { usePointStyle: true, color: '#333' } },
      tooltip: {
        callbacks: {
          label: function (context) {
            return `${context.dataset.label}: ${context.raw.toFixed(2)} hrs`;
          }
        }
      }
    },
    scales: {
      y: {
        beginAtZero: true,
        title: { display: true, text: 'Hours' }
      }
    }
  };

  return (
    <Div>
      <Jumbotron>
        {isLoading ? (
          <div className="text-center mt-4">
            <div className="spinner-border text-primary" role="status">
              <span className="sr-only">Loading data...</span>
            </div>
            <p style={{ color: '#000' }}>Loading team metrics...</p>
          </div>
        ) : (
          <>
            <Row>
              <Col xs={12} md={6} className="text-dark">
                {/* <h4 className="mb-3">Billable Hours Trend</h4>
                <div className="w-100">
                  <Line data={chartData} options={chartOptions} />
                </div> */}
              </Col>


              <Col className="mx-auto text-dark text-md-right d-flex flex-column align-items-end justify-content-center">
                <h3 className="display-4 mb-3">Hello, {teamMemberName}!</h3>

                <div style={{ width: 250, height: 250, position: 'relative', marginBottom: '15px' }}>
                  {/* <CircularProgressbar
                    value={renderBillableHours}
                    strokeWidth={4}
                    maxValue={currentMonthData.goal}
                    styles={buildStyles({
                      pathColor:
                        renderBillableHours / currentMonthData.goal >= 0.9
                          ? 'green'
                          : renderBillableHours / currentMonthData.goal >= 0.75
                          ? 'orange'
                          : 'red',
                      textColor: '#333',
                      trailColor: '#eee',
                      textSize: '0px'
                    })}
                  /> */}

                    <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', textAlign: 'center', lineHeight: 1.4 }}>
                      <div style={{ fontSize: '18px', fontWeight: 'bold' }}>Total Hours: {renderTotalHours.toFixed(2)}</div>
                      {/* <hr style={{ borderColor: 'black' }} />
                    {/* <div style={{ fontSize: '14px', fontWeight: 'bold' }}>Monthly Billable Goal:</div>
                    <div style={{ fontSize: '16px' }}>{renderBillableHours.toFixed(2)} / {currentMonthData.goal.toFixed(2)}</div>
                      {/*<div style={{ fontSize: '16px' }}>{((renderBillableHours / renderTotalHours) * 100 || 0).toFixed(0)}% Billable</div>*/}
                  </div> 
                </div>

                {/* <p><strong>Billable Hours Remaining for Current Month:</strong> {(currentMonthData.goal - renderBillableHours).toFixed(2)} hrs</p> */}
              </Col>
            </Row>

            {/* <hr style={{ borderColor: 'black' }} />

            <Row className="text-dark text-center mt-4 justify-content-center">
              {monthlyRollup.map((month, i) => {
                const [year, monthIndex] = month.key.split('-');
                const label = new Date(year, monthIndex - 1).toLocaleString('en', { month: 'long', year: 'numeric' });
                return (
                  <Col key={month.key} xs={12} sm={6} md={4} lg={3} xl={2} className="mb-4">
                    <h5>{label}</h5>
                  {(() => {
                    const filteredWeeks = month.weeks.filter(week => week.workdays > 0);
                    return filteredWeeks.map((week, idx) => {
                      const progress = Math.min((week.billable_hours / week.goal) * 100, 100);
                      const color = progress >= 100 ? 'green' : progress >= 75 ? 'orange' : 'red';
                      const widthScale = week.workdays / 5;
                      return (
                        <div key={idx} style={{ marginBottom: '6px' }}>
                          <OverlayTrigger
                            placement="top"
                            overlay={
                              <Tooltip id={`tooltip-${i}-${idx}`}>
                                <div style={{ whiteSpace: 'pre-line' }}>
                                  {`Week: ${week.start} - ${week.end}
                                    Billable: ${week.billable_hours.toFixed(2)} hrs
                                    Goal: ${week.goal.toFixed(2)} hrs`}
                                </div>
                              </Tooltip>
                            }
                          >
                            <div style={{ background: '#e0e0e0', height: '10px', borderRadius: '5px', overflow: 'hidden', width: `${widthScale * 100}%`, marginLeft: idx === 0 ? 'auto' : idx === filteredWeeks.length - 1 ? '0' : 'auto', marginRight: idx === 0 ? '0' : idx === filteredWeeks.length - 1 ? 'auto' : 'auto', cursor: 'pointer' }}>
                              <div style={{ width: `${progress}%`, height: '100%', backgroundColor: color }}></div>
                            </div>
                          </OverlayTrigger>
                        </div>
                      );
                    });
                  })()}
                </Col>);
              })}
            </Row> */}
          </>
        )}
      </Jumbotron>
    </Div>
  );
};

export default Profile;
